import type { ReactNode } from 'react';

import { cn } from '@/utils/cn';

import styles from './DetailList.module.css';

export interface DetailItem {
  label: string;
  value: ReactNode;
  /** Spans both columns — for long values such as an address. */
  wide?: boolean;
}

export interface DetailListProps {
  items: readonly DetailItem[];
  columns?: 1 | 2;
  className?: string | undefined;
}

/** Label / value pairs, e.g. a profile. An empty value shows a dash. */
export function DetailList({ items, columns = 2, className }: DetailListProps) {
  return (
    <dl className={cn(styles.list, columns === 2 && styles.twoColumns, className)}>
      {items.map((item) => (
        <div key={item.label} className={cn(styles.item, item.wide && styles.wide)}>
          <dt className={styles.label}>{item.label}</dt>
          <dd className={styles.value}>
            {item.value === null || item.value === undefined || item.value === '' ? (
              <span className={styles.empty}>—</span>
            ) : (
              item.value
            )}
          </dd>
        </div>
      ))}
    </dl>
  );
}
